import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-3" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "fa fa-bookmark mr-1 text-warning" }, null, -1)
const _hoisted_6 = { class: "col-md-9" }
const _hoisted_7 = { class: "text-lg-right" }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "fa fa-chevron-left mr-2" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode()
const _hoisted_10 = { class: "card mt-4" }
const _hoisted_11 = { class: "form-wrap" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { for: "" }
const _hoisted_16 = { class: "email-tag" }
const _hoisted_17 = { class: "mb-0" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = { class: "inline-items" }
const _hoisted_20 = /*#__PURE__*/_createVNode("label", { for: "" }, "Select Phase", -1)
const _hoisted_21 = { class: "inline-items mb-2" }
const _hoisted_22 = { class: "mr-3" }
const _hoisted_23 = { class: "form-check form-check-inline" }
const _hoisted_24 = {
  for: "",
  title: "Phase Name"
}
const _hoisted_25 = {
  class: "form-check-label",
  for: "inlineCheckbox1"
}
const _hoisted_26 = { class: "accordion-wrap" }
const _hoisted_27 = {
  class: "accordion",
  id: "accordionExample"
}
const _hoisted_28 = { class: "mb-0" }
const _hoisted_29 = { class: "card-body border mt-3 rounded p-3 share-block" }
const _hoisted_30 = { class: "absolute-text" }
const _hoisted_31 = { class: "inline-items" }
const _hoisted_32 = {
  class: "form-check-label",
  for: "inlineCheckbox11"
}
const _hoisted_33 = {
  key: 0,
  class: "alert alert-danger rounded mb-3 text-center p-2"
}
const _hoisted_34 = /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_35 = { class: "col-md-6" }
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = { class: "form-check form-check-inline" }
const _hoisted_38 = {
  class: "form-check-label",
  for: "inlineCheckbox2"
}
const _hoisted_39 = { class: "form-group mt-3" }
const _hoisted_40 = { class: "modal-wrap default-modal" }
const _hoisted_41 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "successfulModal",
  tabindex: "-1",
  "aria-labelledby": "inviteMember",
  "aria-hidden": "true"
}
const _hoisted_42 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_43 = { class: "modal-content text-center" }
const _hoisted_44 = { class: "msg-header" }
const _hoisted_45 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_46 = /*#__PURE__*/_createVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    class: "bi bi-check-circle",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z"
    })
  ])
], -1)
const _hoisted_47 = { class: "msg-body" }
const _hoisted_48 = {
  class: "alert alert-success text-center",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToDoListBreadCrumb = _resolveComponent("ToDoListBreadCrumb")
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_Multiselect = _resolveComponent("Multiselect")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_ToDoListBreadCrumb, {
      project: _ctx.state.data.project,
      breadCrumbEndPoint: _ctx.state.data.endPoint
    }, null, 8, ["project", "breadCrumbEndPoint"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("h1", _hoisted_4, [
            _hoisted_5,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('invitation_members_update')), 1)
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("a", {
              href: "javascript:void(0)",
              class: "btn default-btn outline d-inline-block mr-2 mb-1",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redirectToInvitation && _ctx.redirectToInvitation(...args)))
            }, [
              _hoisted_8,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('go_back')), 1)
            ])
          ])
        ])
      ])
    ]),
    _hoisted_9,
    _createVNode("div", _hoisted_10, [
      _createVNode("div", _hoisted_11, [
        _createVNode(_component_ErrorList, {
          errors: _ctx.state.errorList,
          hasError: _ctx.state.isErrorStatus
        }, null, 8, ["errors", "hasError"]),
        _createVNode("div", _hoisted_12, [
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              _createVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('invite_member')), 1),
              _createVNode("div", _hoisted_16, [
                _createVNode("p", _hoisted_17, _toDisplayString(_ctx.state.data.inviteUser), 1)
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_18, [
          _createVNode("div", _hoisted_19, [
            _hoisted_20,
            _createVNode(_component_Multiselect, {
              modelValue: _ctx.state.data.selectPhase,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.data.selectPhase = $event)),
              mode: "tags",
              searchable: true,
              placeholder: "Select Phase",
              select: _ctx.state.data.selected,
              options: _ctx.state.data.phaseList,
              "close-on-select": true,
              "create-option": true
            }, null, 8, ["modelValue", "select", "options"])
          ])
        ]),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.phaseTaskList, (phase, phaseIndex) => {
          return (_openBlock(), _createBlock("div", {
            class: "alert alert-primary rounded mb-2 p-3",
            key: phaseIndex
          }, [
            _createVNode("div", _hoisted_21, [
              _createVNode("ul", null, [
                _createVNode("li", _hoisted_22, [
                  _createVNode("div", _hoisted_23, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      "onUpdate:modelValue": ($event: any) => (phase.isChecked = $event),
                      onChange: ($event: any) => (_ctx.phaseCheck(phaseIndex, phase.isChecked))
                    }, null, 40, ["onUpdate:modelValue", "onChange"]), [
                      [_vModelCheckbox, phase.isChecked]
                    ]),
                    _createVNode("label", _hoisted_24, _toDisplayString(phase.name), 1)
                  ])
                ]),
                _createVNode("li", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(phase.attributes, (att, attIndex) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "form-check form-check-inline",
                      key: attIndex
                    }, [
                      _withDirectives(_createVNode("input", {
                        type: "checkbox",
                        disabled: att.code=='name',
                        "onUpdate:modelValue": ($event: any) => (att.isChecked = $event),
                        onChange: ($event: any) => (_ctx.checkPhaseRole(phaseIndex, attIndex))
                      }, null, 40, ["disabled", "onUpdate:modelValue", "onChange"]), [
                        [_vModelCheckbox, att.isChecked]
                      ]),
                      _createVNode("label", _hoisted_25, [
                        _createVNode("small", null, _toDisplayString(att.name), 1)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createVNode("div", _hoisted_26, [
              _createVNode("div", _hoisted_27, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(phase.tasks, (task, taskIndex) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "card rounded mb-2",
                    key: taskIndex
                  }, [
                    _createVNode("div", {
                      class: "card-header bg-white p-0 border-0",
                      id: `heading${task.uuid}`
                    }, [
                      _createVNode("h2", _hoisted_28, [
                        _createVNode("button", {
                          class: "btn btn-link btn-block text-left collapsed p-0",
                          type: "button",
                          "data-toggle": "collapse",
                          "data-target": `#collapse${task.uuid}`,
                          "aria-expanded": "false",
                          "aria-controls": `collapse${task.uuid}`
                        }, [
                          _withDirectives(_createVNode("input", {
                            class: "form-check-input",
                            type: "checkbox",
                            "onUpdate:modelValue": ($event: any) => (task.isChecked = $event),
                            onChange: ($event: any) => (_ctx.checkTask(phaseIndex, taskIndex, task.isChecked))
                          }, null, 40, ["onUpdate:modelValue", "onChange"]), [
                            [_vModelCheckbox, task.isChecked]
                          ]),
                          _createTextVNode(" " + _toDisplayString(task.name), 1)
                        ], 8, ["data-target", "aria-controls"])
                      ])
                    ], 8, ["id"]),
                    _createVNode("div", {
                      id: `collapse${task.uuid}`,
                      class: "collapse",
                      "aria-labelledby": `heading${task.uuid}`,
                      "data-parent": "#accordionExample"
                    }, [
                      _createVNode("div", _hoisted_29, [
                        _createVNode("div", _hoisted_30, [
                          _createVNode("small", null, _toDisplayString(_ctx.$t('things_to_share')), 1)
                        ]),
                        _createVNode("div", _hoisted_31, [
                          _createVNode("ul", null, [
                            _createVNode("li", null, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(task.attributes, (attTask, attTaskIndex) => {
                                return (_openBlock(), _createBlock("div", {
                                  class: "form-check form-check-inline",
                                  key: attTaskIndex
                                }, [
                                  _withDirectives(_createVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    disabled: attTask.code=='name',
                                    "onUpdate:modelValue": ($event: any) => (attTask.isChecked = $event),
                                    onChange: ($event: any) => (_ctx.checkTaskRole(phaseIndex, taskIndex, attTaskIndex))
                                  }, null, 40, ["disabled", "onUpdate:modelValue", "onChange"]), [
                                    [_vModelCheckbox, attTask.isChecked]
                                  ]),
                                  _createVNode("label", _hoisted_32, [
                                    _createVNode("small", null, _toDisplayString(attTask.name), 1)
                                  ])
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ])
                    ], 8, ["id", "aria-labelledby"])
                  ]))
                }), 128))
              ])
            ])
          ]))
        }), 128)),
        (_ctx.state.data.phaseTaskList.length == 0)
          ? (_openBlock(), _createBlock("div", _hoisted_33, [
              _createVNode("p", null, [
                _hoisted_34,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('no_one_phase_selected')), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_35, [
          _createVNode("div", _hoisted_36, [
            _createVNode("div", _hoisted_37, [
              _withDirectives(_createVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                id: "inlineCheckbox2",
                value: "true",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.data.isIndividualAccept = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.state.data.isIndividualAccept]
              ]),
              _createVNode("label", _hoisted_38, _toDisplayString(_ctx.$t('individual_acceptance_required')), 1)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_39, [
          _createVNode("button", {
            type: "submit",
            class: "btn default-btn d-inline-block mr-2",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.UpdateInvitation && _ctx.UpdateInvitation(...args)))
          }, _toDisplayString(_ctx.state.ui.isPostLoading.updateInvitation? _ctx.$t('update_inviting') : _ctx.$t('update')), 1)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_40, [
      _createVNode("div", _hoisted_41, [
        _createVNode("div", _hoisted_42, [
          _createVNode("div", _hoisted_43, [
            _createVNode("div", _hoisted_44, [
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeSuccessModal && _ctx.closeSuccessModal(...args))),
                onKeydown: _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => (_ctx.closeSuccessModal && _ctx.closeSuccessModal(...args)), ["esc"])),
                "aria-label": "Close"
              }, [
                _hoisted_45
              ], 32),
              _hoisted_46
            ]),
            _createVNode("div", _hoisted_47, [
              _createVNode("h3", null, _toDisplayString(_ctx.$t('successful')) + "!", 1),
              _createVNode("div", _hoisted_48, _toDisplayString(_ctx.state.data.successFulMessage), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}